export class GridColumnProperties {
  width?: number;
  filterable?: boolean;
  filterColumnType?: FilterColumnType;
  showFilterOperators?: boolean;
  locked?: boolean;
  exportAsValue?: boolean;
  sortable?: boolean;
}

export enum FilterColumnType {
  string = 'text',
  number = 'numeric',
  boolean = 'boolean',
  date = 'date',
}
